import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import { useTranslation } from 'react-i18next';
import MainStoreBtn from '@atoms/btn/MainStoreBtn';
import IntroduceBtn from '@atoms/btn/IntroduceBtn';
import { isMobileWithOutIpad } from '@helpers/EnvHelper';

const SectionIntroduce = ({ introRef }) => {
  const { i18n, t } = useTranslation();
  const [onActiveIndex, setOnActiveIndex] = useState(0);
  useEffect(() => {}, []);

  const mobileSectionStyle = {
    backgroundImage: 'url(/img/v2/main/mobile/bg/bg_introduce.png)',
    backgroundSize: '50%',
    backgroundPosition: 'right 0 top 0  ',
    backgroundRepeat: 'no-repeat',
  };

  const sectionStyle = {
    backgroundImage: 'url(/img/v2/main/mobile/bg/bg_introduce.png)',
    backgroundSize: '40%',
    backgroundPosition: 'right 0 top 110px',
    backgroundRepeat: 'no-repeat',
  };

  return (
    <div
      className=" m-auto text-center pt-20 hug:pt-0  px-[15px] xs:px-[30px]"
      style={isMobileWithOutIpad() ? mobileSectionStyle : sectionStyle}
    >
      <p
        ref={introRef}
        className="pt-[19%]  hug:pt-[10%] xhug:pt-[5%]  text-[#bc9dff] font-nuniSans text-3xl  md:text-4xl font-bold "
      >
        {t('함께 쉬기 위해 만든 섬')},
      </p>
      <p className="text-[#bc9dff] font-extrabold top-0 left-0 right-0 font-TmoneyRoundWind  #xxxs:text-3xl text-4xl xs:text-5xl text-4xl xs:text-5xl md:text-6xl">
        {t('인더섬')}
      </p>
      <p className="pt-5 xs:pt-10 text-[#989898]  text-md sm:text-xl md:text-2xl">
        {t("BTS와 함께 하는 짜릿한 퍼즐 게임 '인더섬'")}
      </p>
      <div className="max-w-[1000px]  m-auto  ">
        <ul className="introduce_box text-center text-md pt-5 xs:pt-10">
          <li className="grid grid-cols-2 relative gap-[6px] sm:grid-cols-4">
            <IntroduceBtn
              text={'퍼즐'}
              isActive={onActiveIndex === 0}
              onClick={() => setOnActiveIndex(0)}
            />

            <IntroduceBtn
              text={'섬꾸미기'}
              isActive={onActiveIndex === 1}
              onClick={() => setOnActiveIndex(1)}
            />

            <IntroduceBtn
              text={'스타일링'}
              isActive={onActiveIndex === 2}
              onClick={() => setOnActiveIndex(2)}
              addClass={'hidden sm:inline-block'}
            />

            <IntroduceBtn
              text={'스토리'}
              isActive={onActiveIndex === 3}
              onClick={() => setOnActiveIndex(3)}
              addClass={'hidden sm:inline-block'}
            />
          </li>
          <li className="mt-2 grid grid-cols-2 relative gap-[6px]  sm:grid-cols-4  inline-block sm:hidden">
            <IntroduceBtn
              text={'스타일링'}
              isActive={onActiveIndex === 2}
              onClick={() => setOnActiveIndex(2)}
            />

            <IntroduceBtn
              text={'스토리'}
              isActive={onActiveIndex === 3}
              onClick={() => setOnActiveIndex(3)}
            />
          </li>
        </ul>
        <div className="mt-5 xs:mt-10 w-full ">
          <img
            src={`/img/v2/main/introduce/intro_${onActiveIndex + 1}_${
              i18n.language
            }.png`}
            className="w-full inline-block rounded-[23px] sm:rounded-[50px]"
          />
        </div>
      </div>

      <div className="w-full max-w-[1200px] m-auto pt-[60px]  pb-5`` xs:pb-10 text-center sm:px-20 ">
        <MainStoreBtn />
      </div>
    </div>
  );
};

export default observer(SectionIntroduce);
